import { useQuery } from '@tanstack/react-query';

import { getBreakpointWinnerCampaignStatus } from '@/api/auth';

export function useBreakpointWinnerCampaign() {
  const query = useQuery({
    queryKey: ['breakpointWinnerCampaign'],
    queryFn: async () => {
      const response = await getBreakpointWinnerCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
